var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_notification_outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10.429,
    viewBox: "0 0 10 10.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_notification_outline-2",
    "data-name": "Icon_notification_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,.549A.549.549,0,0,1,.549,0H9.331a.549.549,0,0,1,0,1.1H.549A.549.549,0,0,1,0,.549Z",
    transform: "translate(0 7.684)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.543,1.9A2.518,2.518,0,0,0,1.1,3.293V7.135H0V3.293A3.614,3.614,0,0,1,.652,1.257,3.092,3.092,0,0,1,3.293,0,3.092,3.092,0,0,1,5.934,1.257a3.614,3.614,0,0,1,.652,2.036V7.135h-1.1V3.293A2.518,2.518,0,0,0,5.043,1.9a2,2,0,0,0-1.75-.8A2,2,0,0,0,1.543,1.9Z",
    transform: "translate(1.647 1.098)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M2.2,1.1A1.1,1.1,0,1,1,1.1,0,1.1,1.1,0,0,1,2.2,1.1Z",
    transform: "translate(3.842)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M1.1,1.1A1.1,1.1,0,0,0,2.2,0H0A1.1,1.1,0,0,0,1.1,1.1Z",
    transform: "translate(3.842 9.331)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.d216a54e1f18ffba78b66771010542a0.svg";
export { ForwardRef as ReactComponent };